export const profileEn = {
    prestige_club: 'AIA Prestige Club',
    ambassador: '(แอมบาสเดอร์)',
    tier_lvl: {
        'c': 'Classic member',
        's': 'Silver member',
        'g': 'Gold member',
        'p': 'Platinum member'
    },
    privilege_id: 'Privilege ID : ',
    prestige_privilege: 'ยอดใช้เอกสิทธิ์จากโครงการเอไอเอ เพรสทีจ คลับ',

    column_privilege: 'Privileges',
    column_quota: 'Quota',
    column_left: 'Remaining quota',
    column_blank: '',

    remark_headline: 'Remark',
    remark: 'การเปลี่ยนแปลงของยอดเบี้ยประกันภัยรวม ส่งผลต่อสถานะสมาชิกของท่าน ซึ่งเอกสิทธิ์ที่ท่านได้รับจะปรับเปลี่ยนตามสถานะของท่าน ตามเงื่อนไขในแต่ละเอกสิทธิ์'
}
